import React, { useContext, useEffect, useReducer, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useHelps from "../hooks/useHelps";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";

import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CodeRoundedIcon from "@material-ui/icons/CodeRounded";
import AssignmentIcon from "@material-ui/icons/Assignment";
import ViewKanban from "@mui/icons-material/ViewKanban";
import Schedule from "@material-ui/icons/Schedule";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PeopleIcon from "@material-ui/icons/People";
import ListIcon from "@material-ui/icons/ListAlt";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import ForumIcon from "@material-ui/icons/Forum";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import BusinessIcon from "@material-ui/icons/Business";
import HeadsetMicIcon from "@material-ui/icons/HeadsetMic";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import LanguageIcon from "@material-ui/icons/Language";
import CloseIcon from "@material-ui/icons/Close";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import {
  AllInclusive,
  AttachFile,
  Dashboard,
  Description,
  DeviceHubOutlined,
  GridOn,
  ListAlt,
  PhonelinkSetup,
  SettingsApplications
} from "@material-ui/icons";
import SignalCellularConnectedNoInternet4BarIcon from "@material-ui/icons/SignalCellularConnectedNoInternet4Bar";

import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";
import { useActiveMenu } from "../context/ActiveMenuContext";

import { Can } from "../components/Can";

import { isArray } from "lodash";
import api from "../services/api";
import toastError from "../errors/toastError";
import usePlans from "../hooks/usePlans";
import useVersion from "../hooks/useVersion";
import { i18n } from "../translate/i18n";
import { Campaign, ShapeLine, Webhook } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  // Estilos modernos do Dialog de Suporte
  dialogPaper: {
    borderRadius: '12px',
    maxWidth: '480px',
    width: '90vw',
    backgroundColor: theme.palette.background.paper,
  },
  dialogTitle: {
    padding: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  titleIconWrapper: {
    width: 40,
    height: 40,
    backgroundColor: theme.mode === 'light' ? '#f5f5f5' : 'rgba(255, 255, 255, 0.08)',
    color: theme.palette.text.secondary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
  },
  titleTextWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  titleMain: {
    fontSize: '18px',
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1.3,
  },
  titleSub: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
  closeButton: {
    color: theme.palette.text.secondary,
    padding: 8,
    '&:hover': {
      backgroundColor: theme.mode === 'light' ? '#f5f5f5' : 'rgba(255, 255, 255, 0.08)',
    },
  },
  dialogContent: {
    padding: theme.spacing(3),
    backgroundColor: theme.mode === 'light' ? '#fafafa' : theme.palette.background.default,
  },
  infoSection: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: '8px',
    padding: theme.spacing(2.5),
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
  },
  infoHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  infoIcon: {
    width: 48,
    height: 48,
    backgroundColor: theme.mode === 'light' ? '#f5f5f5' : 'rgba(255, 255, 255, 0.08)',
    color: theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    fontSize: '24px',
    fontWeight: 600,
  },
  infoTextWrapper: {
    flex: 1,
  },
  infoName: {
    fontSize: '16px',
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1.3,
  },
  infoRole: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
  contactList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  contactItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5),
    backgroundColor: theme.mode === 'light' ? '#fafafa' : 'rgba(255, 255, 255, 0.03)',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: '1px solid transparent',
    '&:hover': {
      backgroundColor: theme.mode === 'light' ? '#f5f5f5' : 'rgba(255, 255, 255, 0.08)',
      borderColor: theme.palette.divider,
      transform: 'translateX(4px)',
    },
  },
  contactIconCircle: {
    width: 36,
    height: 36,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.secondary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    flexShrink: 0,
  },
  contactTextWrapper: {
    flex: 1,
    minWidth: 0,
  },
  contactLabel: {
    fontSize: '11px',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontWeight: 500,
    marginBottom: 2,
  },
  contactValue: {
    fontSize: '13px',
    color: theme.palette.text.primary,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  // Estilos modernos dos itens do menu
  menuItem: {
    position: 'relative',
    borderRadius: '8px',
    margin: '4px 8px',
    transition: 'all 0.2s ease',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      width: 3,
      background: 'transparent',
      borderRadius: '0 3px 3px 0',
      transition: 'all 0.2s ease',
    },
    '&:hover': {
      backgroundColor: theme.mode === 'light' ? '#f1f5f9' : 'rgba(255, 255, 255, 0.08)',
      paddingLeft: theme.spacing(2.5),
    },
  },
  menuItemActive: {
    backgroundColor: theme.mode === 'light' ? '#e0f2fe' : 'rgba(14, 165, 233, 0.15)',
    color: theme.palette.primary.main,
    '&::before': {
      background: theme.palette.primary.main,
    },
    '& .MuiListItemIcon-root': {
      color: theme.palette.primary.main,
    },
  },
  menuSectionTitle: {
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.text.secondary,
    opacity: 0.7,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
    padding: `0 ${theme.spacing(2)}px`,
  },
  // Novos estilos para layout fixo
  drawerContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },
  menuScrollArea: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: theme.spacing(1, 0),
    '&::-webkit-scrollbar': {
      width: 6,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.divider,
      borderRadius: 3,
      '&:hover': {
        background: theme.palette.text.disabled,
      },
    },
  },
  supportSection: {
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    flexShrink: 0,
  },
  supportButton: {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: '8px',
    padding: theme.spacing(1.5),
    transition: 'all 0.2s ease',
    justifyContent: 'flex-start',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      transform: 'translateY(-2px)',
      boxShadow: theme.shadows[4],
    },
  },
  supportButtonCollapsed: {
    justifyContent: 'center',
    padding: theme.spacing(1),
    minWidth: 0,
  },
}));

function ListItemLink(props) {
  const { icon, primary, to, className } = props;
  const classes = useStyles();
  const location = useLocation();
  const isActive = location.pathname === to;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to]
  );

  return (
    <li>
      <ListItem 
        dense 
        button 
        component={renderLink} 
        className={`${classes.menuItem} ${isActive ? classes.menuItemActive : ''} ${className || ''}`}
      >
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText primary={primary} />
      </ListItem>
    </li>
  );
}

const reducer = (state, action) => {
  if (action.type === "LOAD_CHATS") {
    const chats = action.payload;
    const newChats = [];

    if (isArray(chats)) {
      chats.forEach((chat) => {
        const chatIndex = state.findIndex((u) => u.id === chat.id);
        if (chatIndex !== -1) {
          state[chatIndex] = chat;
        } else {
          newChats.push(chat);
        }
      });
    }

    return [...state, ...newChats];
  }

  if (action.type === "UPDATE_CHATS") {
    const chat = action.payload;
    const chatIndex = state.findIndex((u) => u.id === chat.id);

    if (chatIndex !== -1) {
      state[chatIndex] = chat;
      return [...state];
    } else {
      return [chat, ...state];
    }
  }

  if (action.type === "DELETE_CHAT") {
    const chatId = action.payload;

    const chatIndex = state.findIndex((u) => u.id === chatId);
    if (chatIndex !== -1) {
      state.splice(chatIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }

  if (action.type === "CHANGE_CHAT") {
    const changedChats = state.map((chat) => {
      if (chat.id === action.payload.chat.id) {
        return action.payload.chat;
      }
      return chat;
    });
    return changedChats;
  }
};

const MainListItems = ({ collapsed, drawerClose }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { whatsApps } = useContext(WhatsAppsContext);
  const { user, socket } = useContext(AuthContext);
  const { setActiveMenu } = useActiveMenu();
  const location = useLocation();

  const [connectionWarning, setConnectionWarning] = useState(false);
  const [openCampaignSubmenu, setOpenCampaignSubmenu] = useState(false);
  const [openFlowSubmenu, setOpenFlowSubmenu] = useState(false);
  const [openDashboardSubmenu, setOpenDashboardSubmenu] = useState(false);
  const [showCampaigns, setShowCampaigns] = useState(false);
  const [showKanban, setShowKanban] = useState(false);
  const [showOpenAi, setShowOpenAi] = useState(false);
  const [showIntegrations, setShowIntegrations] = useState(false);

  const [showSchedules, setShowSchedules] = useState(false);
  const [showInternalChat, setShowInternalChat] = useState(false);
  const [showExternalApi, setShowExternalApi] = useState(false);

  const [invisible, setInvisible] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchParam] = useState("");
  const [chats, dispatch] = useReducer(reducer, []);
  const [version, setVersion] = useState(false);
  const { list } = useHelps();
  const [hasHelps, setHasHelps] = useState(false);
  
  const [openSupportDialog, setOpenSupportDialog] = useState(false);

  useEffect(() => {
    async function checkHelps() {
      const helps = await list();
      setHasHelps(helps.length > 0);
    }
    checkHelps();
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith("/tickets")) {
      setActiveMenu("/tickets");
    } else {
      setActiveMenu("");
    }
  }, [location, setActiveMenu]);

  const { getPlanCompany } = usePlans();
  const { getVersion } = useVersion();

  useEffect(() => {
    async function fetchVersion() {
      const _version = await getVersion();
      setVersion(_version.version);
    }
    fetchVersion();
  }, []);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);

      setShowCampaigns(planConfigs.plan.useCampaigns);
      setShowKanban(planConfigs.plan.useKanban);
      setShowOpenAi(planConfigs.plan.useOpenAi);
      setShowIntegrations(planConfigs.plan.useIntegrations);
      setShowSchedules(planConfigs.plan.useSchedules);
      setShowInternalChat(planConfigs.plan.useInternalChat);
      setShowExternalApi(planConfigs.plan.useExternalApi);
    }
    fetchData();
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchChats();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber]);

  useEffect(() => {
    if (user.id) {
      const companyId = user.companyId;
      const onCompanyChatMainListItems = (data) => {
        if (data.action === "new-message") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        }
        if (data.action === "update") {
          dispatch({ type: "CHANGE_CHAT", payload: data });
        }
      };

      socket.on(`company-${companyId}-chat`, onCompanyChatMainListItems);
      return () => {
        socket.off(`company-${companyId}-chat`, onCompanyChatMainListItems);
      };
    }
  }, [socket]);

  useEffect(() => {
    let unreadsCount = 0;
    if (chats.length > 0) {
      for (let chat of chats) {
        for (let chatUser of chat.users) {
          if (chatUser.userId === user.id) {
            unreadsCount += chatUser.unreads;
          }
        }
      }
    }
    if (unreadsCount > 0) {
      setInvisible(false);
    } else {
      setInvisible(true);
    }
  }, [chats, user.id]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter((whats) => {
          return (
            whats.status === "qrcode" ||
            whats.status === "PAIRING" ||
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT" ||
            whats.status === "OPENING"
          );
        });
        if (offlineWhats.length > 0) {
          setConnectionWarning(true);
        } else {
          setConnectionWarning(false);
        }
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);

  const fetchChats = async () => {
    try {
      const { data } = await api.get("/chats/", {
        params: { searchParam, pageNumber },
      });
      dispatch({ type: "LOAD_CHATS", payload: data.records });
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenSupportDialog = () => {
    setOpenSupportDialog(true);
  };

  const handleCloseSupportDialog = () => {
    setOpenSupportDialog(false);
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5541998239551', '_blank');
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:contato@conectai.cloud';
  };

  const handleWebsiteClick = () => {
    window.open('https://conectai.cloud', '_blank');
  };

  return (
    <div className={classes.drawerContainer}>
      {/* Menu Scroll Area - Área com scroll */}
      <div className={classes.menuScrollArea}>
        <div onClick={drawerClose}>
          <Can
            role={
              (user.profile === "user" && user.showDashboard === "enabled") ||
              user.allowRealTime === "enabled"
                ? "admin"
                : user.profile
            }
            perform={"drawer-admin-items:view"}
            yes={() => (
              <>
                <Typography className={classes.menuSectionTitle}>
                  {i18n.t("mainDrawer.listItems.management")}
                </Typography>
                <ListItem
                  dense
                  button
                  onClick={() => setOpenDashboardSubmenu((prev) => !prev)}
                  className={classes.menuItem}
                >
                  <ListItemIcon>
                    <Dashboard />
                  </ListItemIcon>
                  <ListItemText primary={i18n.t("mainDrawer.listItems.management")} />
                  {openDashboardSubmenu ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItem>
                <Collapse
                  style={{ paddingLeft: 15 }}
                  in={openDashboardSubmenu}
                  timeout="auto"
                  unmountOnExit
                >
                  <Can
                    role={
                      user.profile === "user" && user.showDashboard === "enabled"
                        ? "admin"
                        : user.profile
                    }
                    perform={"drawer-admin-items:view"}
                    yes={() => (
                      <>
                        <ListItemLink
                          to="/"
                          primary="Dashboard"
                          icon={<DashboardOutlinedIcon />}
                        />
                        <ListItemLink
                          to="/reports"
                          primary={i18n.t("mainDrawer.listItems.reports")}
                          icon={<Description />}
                        />
                      </>
                    )}
                  />
                  <Can
                    role={
                      user.profile === "user" && user.allowRealTime === "enabled"
                        ? "admin"
                        : user.profile
                    }
                    perform={"drawer-admin-items:view"}
                    yes={() => (
                      <ListItemLink
                        to="/moments"
                        primary={i18n.t("mainDrawer.listItems.chatsTempoReal")}
                        icon={<GridOn />}
                      />
                    )}
                  />
                </Collapse>
              </>
            )}
          />
          
          <Typography className={classes.menuSectionTitle}>
            Principal
          </Typography>

          <ListItemLink
            to="/tickets"
            primary={i18n.t("mainDrawer.listItems.tickets")}
            icon={<WhatsAppIcon />}
          />

          <ListItemLink
            to="/quick-messages"
            primary={i18n.t("mainDrawer.listItems.quickMessages")}
            icon={<FlashOnIcon />}
          />

          {showKanban && (
            <ListItemLink
              to="/kanban"
              primary={i18n.t("mainDrawer.listItems.kanban")}
              icon={<ViewKanban />}
            />
          )}

          <ListItemLink
            to="/contacts"
            primary={i18n.t("mainDrawer.listItems.contacts")}
            icon={<ContactPhoneOutlinedIcon />}
          />

          <ListItemLink
            to="/important-client-notes"
            primary={i18n.t("mainDrawer.listItems.importantClientNotes")}
            icon={<AssignmentIcon />}
          />

          <Typography className={classes.menuSectionTitle}>
            Ferramentas
          </Typography>

          {showSchedules && (
            <ListItemLink
              to="/schedules"
              primary={i18n.t("mainDrawer.listItems.schedules")}
              icon={<Schedule />}
            />
          )}

          <ListItemLink
            to="/tags"
            primary={i18n.t("mainDrawer.listItems.tags")}
            icon={<LocalOfferIcon />}
          />

          {showInternalChat && (
            <ListItemLink
              to="/chats"
              primary={i18n.t("mainDrawer.listItems.chats")}
              icon={
                <Badge color="secondary" variant="dot" invisible={invisible}>
                  <ForumIcon />
                </Badge>
              }
            />
          )}

          {hasHelps && (
            <ListItemLink
              to="/helps"
              primary={i18n.t("mainDrawer.listItems.helps")}
              icon={<HelpOutlineIcon />}
            />
          )}

          <Can
            role={
              user.profile === "user" && user.allowConnections === "enabled"
                ? "admin"
                : user.profile
            }
            perform="dashboard:view"
            yes={() => (
              <>
                {showCampaigns && (
                  <Can
                    role={user.profile}
                    perform="dashboard:view"
                    yes={() => (
                      <>
                        <Typography className={classes.menuSectionTitle}>
                          {i18n.t("mainDrawer.listItems.campaigns")}
                        </Typography>
                        <ListItem
                          dense
                          button
                          onClick={() => setOpenCampaignSubmenu((prev) => !prev)}
                          className={classes.menuItem}
                        >
                          <ListItemIcon>
                            <EventAvailableIcon />
                          </ListItemIcon>
                          <ListItemText primary={i18n.t("mainDrawer.listItems.campaigns")} />
                          {openCampaignSubmenu ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </ListItem>
                        <Collapse
                          style={{ paddingLeft: 15 }}
                          in={openCampaignSubmenu}
                          timeout="auto"
                          unmountOnExit
                        >
                          <List dense component="div" disablePadding>
                            <ListItemLink
                              to="/campaigns"
                              primary={i18n.t("campaigns.subMenus.list")}
                              icon={<ListIcon />}
                            />
                            <ListItemLink
                              to="/contact-lists"
                              primary={i18n.t("campaigns.subMenus.listContacts")}
                              icon={<PeopleIcon />}
                            />
                            <ListItemLink
                              to="/campaigns-config"
                              primary={i18n.t("campaigns.subMenus.settings")}
                              icon={<SettingsOutlinedIcon />}
                            />
                          </List>
                        </Collapse>
                      </>
                    )}
                  />
                )}

                <Can
                  role={user.profile}
                  perform="dashboard:view"
                  yes={() => (
                    <>
                      <ListItem
                        dense
                        button
                        onClick={() => setOpenFlowSubmenu((prev) => !prev)}
                        className={classes.menuItem}
                      >
                        <ListItemIcon>
                          <Webhook />
                        </ListItemIcon>
                        <ListItemText primary={i18n.t("mainDrawer.listItems.flowbuilder")} />
                        {openFlowSubmenu ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </ListItem>

                      <Collapse
                        style={{ paddingLeft: 15 }}
                        in={openFlowSubmenu}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List dense component="div" disablePadding>
                          <ListItemLink
                            to="/phrase-lists"
                            primary={i18n.t("flowbuilder.subMenus.campaign")}
                            icon={<EventAvailableIcon />}
                          />
                          <ListItemLink
                            to="/flowbuilders"
                            primary={i18n.t("flowbuilder.subMenus.conversation")}
                            icon={<ShapeLine />}
                          />
                        </List>
                      </Collapse>
                    </>
                  )}
                />

                <Typography className={classes.menuSectionTitle}>
                  Administração
                </Typography>

                {user.super && (
                  <ListItemLink
                    to="/announcements"
                    primary={i18n.t("mainDrawer.listItems.annoucements")}
                    icon={<AnnouncementIcon />}
                  />
                )}

                {showExternalApi && (
                  <Can
                    role={user.profile}
                    perform="dashboard:view"
                    yes={() => (
                      <ListItemLink
                        to="/messages-api"
                        primary={i18n.t("mainDrawer.listItems.messagesAPI")}
                        icon={<CodeRoundedIcon />}
                      />
                    )}
                  />
                )}
                
                <Can
                  role={user.profile}
                  perform="dashboard:view"
                  yes={() => (
                    <ListItemLink
                      to="/users"
                      primary={i18n.t("mainDrawer.listItems.users")}
                      icon={<PeopleAltOutlinedIcon />}
                    />
                  )}
                />
                
                <Can
                  role={user.profile}
                  perform="dashboard:view"
                  yes={() => (
                    <ListItemLink
                      to="/queues"
                      primary={i18n.t("mainDrawer.listItems.queues")}
                      icon={<AccountTreeOutlinedIcon />}
                    />
                  )}
                />

                {showOpenAi && (
                  <Can
                    role={user.profile}
                    perform="dashboard:view"
                    yes={() => (
                      <ListItemLink
                        to="/prompts"
                        primary={i18n.t("mainDrawer.listItems.prompts")}
                        icon={<AllInclusive />}
                      />
                    )}
                  />
                )}

                {showIntegrations && (
                  <Can
                    role={user.profile}
                    perform="dashboard:view"
                    yes={() => (
                      <ListItemLink
                        to="/queue-integration"
                        primary={i18n.t("mainDrawer.listItems.queueIntegration")}
                        icon={<DeviceHubOutlined />}
                      />
                    )}
                  />
                )}
                
                <Can
                  role={
                    user.profile === "user" && user.allowConnections === "enabled"
                      ? "admin"
                      : user.profile
                  }
                  perform={"drawer-admin-items:view"}
                  yes={() => (
                    <ListItemLink
                      to="/connections"
                      primary={i18n.t("mainDrawer.listItems.connections")}
                      icon={
                        <Badge badgeContent={connectionWarning ? "!" : 0} color="error">
                          <SignalCellularConnectedNoInternet4BarIcon />
                        </Badge>
                      }
                    />
                  )}
                />
                
                <Can
                  role={user.profile}
                  perform="dashboard:view"
                  yes={() => (
                    <ListItemLink
                      to="/files"
                      primary={i18n.t("mainDrawer.listItems.files")}
                      icon={<AttachFile />}
                    />
                  )}
                />
                
                <Can
                  role={user.profile}
                  perform="dashboard:view"
                  yes={() => (
                    <ListItemLink
                      to="/financeiro"
                      primary={i18n.t("mainDrawer.listItems.financeiro")}
                      icon={<LocalAtmIcon />}
                    />
                  )}
                />
                
                <Can
                  role={user.profile}
                  perform="dashboard:view"
                  yes={() => (
                    <ListItemLink
                      to="/settings"
                      primary={i18n.t("mainDrawer.listItems.settings")}
                      icon={<SettingsOutlinedIcon />}
                    />
                  )}
                />

                {user.super && (
                  <ListItemLink
                    to="/global-config"
                    primary={i18n.t("globalConfig.title", "Configurações Globais")}
                    icon={<SettingsApplications />}
                  />
                )}

                <ListItemLink
                  to="/integrations"
                  primary="Integrações"
                  icon={<Webhook />}
                />
              </>
            )}
          />
        </div>
      </div>

      {/* Support Section - Fixa no fundo */}
      <div className={classes.supportSection}>
        <ListItem 
          dense 
          button 
          onClick={handleOpenSupportDialog}
          className={`${classes.supportButton} ${collapsed ? classes.supportButtonCollapsed : ''}`}
        >
          <ListItemIcon style={{ color: 'inherit', minWidth: collapsed ? 0 : 40 }}>
            <ContactSupportIcon />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="Suporte Técnico" />}
        </ListItem>
      </div>

      {/* Dialog de Suporte Modernizado */}
      <Dialog 
        open={openSupportDialog} 
        onClose={handleCloseSupportDialog}
        maxWidth={false}
        PaperProps={{
          className: classes.dialogPaper
        }}
      >
        <DialogTitle className={classes.dialogTitle} disableTypography>
          <Box className={classes.titleContainer}>
            <Box className={classes.titleLeft}>
              <Box className={classes.titleIconWrapper}>
                <HeadsetMicIcon style={{ fontSize: 22 }} />
              </Box>
              <Box className={classes.titleTextWrapper}>
                <Typography className={classes.titleMain}>
                  Suporte Técnico
                </Typography>
                <Typography className={classes.titleSub}>
                  Estamos aqui para ajudar
                </Typography>
              </Box>
            </Box>
            <IconButton 
              className={classes.closeButton}
              onClick={handleCloseSupportDialog}
              size="small"
            >
              <CloseIcon style={{ fontSize: 20 }} />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent className={classes.dialogContent}>
          <Box className={classes.infoSection}>
            <Box className={classes.infoHeader}>
              <Box className={classes.infoIcon}>
                G
              </Box>
              <Box className={classes.infoTextWrapper}>
                <Typography className={classes.infoName}>
                  Genivaldo
                </Typography>
                <Typography className={classes.infoRole}>
                  Desenvolvedor
                </Typography>
              </Box>
            </Box>

            <Box className={classes.contactList}>
              <Box className={classes.contactItem} onClick={handleEmailClick}>
                <Box className={classes.contactIconCircle}>
                  <EmailIcon style={{ fontSize: 18 }} />
                </Box>
                <Box className={classes.contactTextWrapper}>
                  <Typography className={classes.contactLabel}>
                    E-mail
                  </Typography>
                  <Typography className={classes.contactValue}>
                    contato@conectai.cloud
                  </Typography>
                </Box>
              </Box>

              <Box className={classes.contactItem} onClick={handleWhatsAppClick}>
                <Box className={classes.contactIconCircle}>
                  <WhatsAppIcon style={{ fontSize: 18 }} />
                </Box>
                <Box className={classes.contactTextWrapper}>
                  <Typography className={classes.contactLabel}>
                    WhatsApp
                  </Typography>
                  <Typography className={classes.contactValue}>
                    +55 (41) 99823-9551
                  </Typography>
                </Box>
              </Box>

              <Box className={classes.contactItem} onClick={handleWebsiteClick}>
                <Box className={classes.contactIconCircle}>
                  <LanguageIcon style={{ fontSize: 18 }} />
                </Box>
                <Box className={classes.contactTextWrapper}>
                  <Typography className={classes.contactLabel}>
                    Website
                  </Typography>
                  <Typography className={classes.contactValue}>
                    https://conectai.cloud
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default MainListItems;